"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlSanitizer = void 0;
/**
 * Sanitizer which filters a set of whitelisted tags, attributes and css.
 *
 * @param bool whether to escape or strip undesirable content.
 * @param map of allowed tag-attribute-attribute-parsers.
 * @param array of allowed css elements.
 * @param array of allowed url scheme
 */
var HtmlSanitizer = /** @class */ (function () {
    function HtmlSanitizer(escape, tags, css, urls) {
        if (escape === void 0) { escape = false; }
        if (tags === void 0) { tags = null; }
        if (css === void 0) { css = null; }
        if (urls === void 0) { urls = null; }
        this.escape = null;
        this.allowedTags = null;
        this.allowedCss = null;
        // Document title cannot be optional in IE11
        this.doc = document.implementation.createHTMLDocument('');
        this.escape = escape;
        this.allowedTags = tags;
        this.allowedCss = css;
        if (urls == null) {
            urls = ['http://', 'https://', 'mailto:', '#', '{'];
        }
        if (this.allowedTags == null) {
            // Configure set of default tags based on what we currently have in production/uat
            var unconstrained = function (x) {
                return x;
            };
            var globalAttributes = {
                dir: unconstrained,
                lang: unconstrained,
                title: unconstrained,
                class: unconstrained,
            };
            var urlSanitizer = this.makeUrlSanitizer(urls);
            this.allowedTags = {
                a: __assign(__assign({}, globalAttributes), { name: unconstrained, href: urlSanitizer, style: unconstrained, target: unconstrained }),
                img: __assign(__assign({}, globalAttributes), { alt: unconstrained, height: unconstrained, src: urlSanitizer, width: unconstrained }),
                font: __assign(__assign({}, globalAttributes), { face: unconstrained, size: unconstrained, color: unconstrained }),
                basefont: __assign(__assign({}, globalAttributes), { face: unconstrained, size: unconstrained, color: unconstrained }),
                div: __assign(__assign({}, globalAttributes), { align: unconstrained, style: unconstrained }),
                span: __assign(__assign({}, globalAttributes), { style: unconstrained }),
                table: __assign(__assign({}, globalAttributes), { align: unconstrained, width: unconstrained, cellspacing: unconstrained, cellpadding: unconstrained, style: unconstrained }),
                tr: __assign(__assign({}, globalAttributes), { bgcolor: unconstrained }),
                td: __assign(__assign({}, globalAttributes), { bgcolor: unconstrained, width: unconstrained, height: unconstrained, align: unconstrained, valign: unconstrained }),
                p: __assign(__assign({}, globalAttributes), { style: unconstrained, align: unconstrained }),
                br: globalAttributes,
                center: globalAttributes,
                u: globalAttributes,
                b: globalAttributes,
                i: globalAttributes,
                strong: globalAttributes,
                em: globalAttributes,
                tbody: globalAttributes,
                ul: globalAttributes,
                ol: globalAttributes,
                li: globalAttributes,
                h1: globalAttributes,
                h2: globalAttributes,
                h3: globalAttributes,
                h4: globalAttributes,
                h5: globalAttributes,
                h6: globalAttributes,
                hr: globalAttributes,
            };
        }
        if (this.allowedCss == null) {
            // Small set of default css properties
            this.allowedCss = [
                'background',
                'background-attachment',
                'background-color',
                'background-image',
                'background-position',
                'background-repeat',
                'border',
                'border-bottom',
                'border-bottom-color',
                'border-bottom-style',
                'border-bottom-width',
                'border-collapse',
                'border-color',
                'border-left',
                'border-left-color',
                'border-left-style',
                'border-left-width',
                'border-right',
                'border-right-color',
                'border-right-style',
                'border-right-width',
                'border-spacing',
                'border-style',
                'border-top',
                'border-top-color',
                'border-top-style',
                'border-top-width',
                'border-width',
                'bottom',
                'caption-side',
                'clear',
                'clip',
                'color',
                'content',
                'counter-increment',
                'counter-reset',
                'cursor',
                'direction',
                'display',
                'empty-cells',
                'float',
                'font',
                'font-family',
                'font-size',
                'font-style',
                'font-variant',
                'font-weight',
                'height',
                'left',
                'letter-spacing',
                'line-height',
                'list-style',
                'list-style-image',
                'list-style-position',
                'list-style-type',
                'margin',
                'margin-bottom',
                'margin-left',
                'margin-right',
                'margin-top',
                'max-height',
                'max-width',
                'min-height',
                'min-width',
                'opacity',
                'orphans',
                'outline',
                'outline-color',
                'outline-style',
                'outline-width',
                'overflow',
                'padding',
                'padding-bottom',
                'padding-left',
                'padding-right',
                'padding-top',
                'page-break-after',
                'page-break-before',
                'page-break-inside',
                'quotes',
                'right',
                'table-layout',
                'text-align',
                'text-decoration',
                'text-indent',
                'text-transform',
                'top',
                'unicode-bidi',
                'vertical-align',
                'visibility',
                'white-space',
                'widows',
                'width',
                'word-spacing',
                'z-index',
            ];
        }
    }
    HtmlSanitizer.prototype.sanitizeText = function (text) {
        return this.sanitizeString(text);
    };
    HtmlSanitizer.prototype.makeUrlSanitizer = function (allowedUrls) {
        return function (str) {
            if (!str) {
                return '';
            }
            for (var i in allowedUrls) {
                if (str.startsWith(allowedUrls[i])) {
                    return str;
                }
            }
            return '';
        };
    };
    HtmlSanitizer.prototype.sanitizeString = function (input) {
        var div = this.doc.createElement('div');
        div.innerHTML = input;
        // Return the sanitized version of the node.
        return this.sanitizeNode(div).innerHTML;
    };
    HtmlSanitizer.prototype.sanitizeNode = function (node) {
        // Note: <form> can have it's nodeName overridden by a child node. It's
        // not a big deal here, so we can punt on this.
        var nodeName = node.nodeName.toLowerCase();
        if (nodeName === '#text') {
            // text nodes are always safe
            return node;
        }
        if (nodeName === '#comment') {
            // always strip comments
            return this.doc.createTextNode('');
        }
        if (!Object.prototype.hasOwnProperty.call(this.allowedTags, nodeName)) {
            // this node isn't allowed
            if (this.escape) {
                return this.doc.createTextNode(node.outerHTML);
            }
            return this.doc.createTextNode('');
        }
        // create a new node
        var copy = this.doc.createElement(nodeName);
        // copy the whitelist of attributes using the per-attribute sanitizer
        for (var nAttr = 0; nAttr < node.attributes.length; nAttr++) {
            var attr = node.attributes.item(nAttr).name;
            if (Object.prototype.hasOwnProperty.call(this.allowedTags[nodeName], attr)) {
                var sanitizer = this.allowedTags[nodeName][attr];
                copy.setAttribute(attr, sanitizer(node.getAttribute(attr)));
            }
        }
        // copy the whitelist of css properties
        for (var _i = 0, _a = Object.keys(this.allowedCss); _i < _a.length; _i++) {
            var css = _a[_i];
            copy.style[this.allowedCss[css]] = node.style[this.allowedCss[css]];
        }
        // recursively sanitize child nodes
        while (node.childNodes.length > 0) {
            var child = node.removeChild(node.childNodes[0]);
            copy.appendChild(this.sanitizeNode(child));
        }
        return copy;
    };
    return HtmlSanitizer;
}());
exports.HtmlSanitizer = HtmlSanitizer;
